/* eslint-disable */

<template>
    <div class="bg-dark main-border rounded-lg h-full">
        <h4 class="p-4">
          {{ activeCourseInfo.name }} Progress
        </h4>

        <div class="flex justify-between items-center main-top-border p-4">
        <div>
          <h4 class="mb-1">Simulations</h4>
          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-check" class="h-5 w-5 text-success" />
            Completed Sims:
            <p v-if="courseInfoFetched">{{ progressData?.simulation?.simulations_completed }}</p>
            <p v-else>0</p>
          </span>

          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-x" class="h-5 w-5 text-danger" />
            Incomplete Sims:
            <p v-if="courseInfoFetched">{{ progressData?.simulation?.simulations_incomplete }}</p>
            <p v-else>0</p>
          </span>

          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-exclamation" class="h-5 w-5 text-warning" />
            Attempted Sims:
            <p v-if="courseInfoFetched">{{ progressData?.simulation?.simulations_attempted }}</p>
            <p v-else>0</p>
          </span>
        </div>
        <div>
          <radial-progress-bar
            :diameter="95"
            :completed-steps="progressData?.simulation?.simulations_completed"
            :total-steps="progressData?.simulation?.simulations_total"
            :animateSpeed="1000"
            timingFunc="ease"
            innerStrokeColor="#222f44"
            startColor="#31B952"
            stopColor="#0cdc62"
            :strokeWidth="6"
            :innerStrokeWidth="6"
          >
            <h2 v-if="courseInfoFetched" class="font-light">{{ progressData?.simulation?.simulations_percent }}%</h2>
            <h2 v-else class="font-light">0%</h2>
          </radial-progress-bar>
        </div>
      </div>


      <div class="flex justify-between items-center main-top-border p-4">
        <div>
          <h4 class="mb-1">FlashCards</h4>
          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-check" class="h-5 w-5 text-success" />
            Completed Sets:
            <p v-if="courseInfoFetched">{{ progressData?.flashcard?.sets_completed }}</p>
            <p v-else>0</p>
          </span>

          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-x" class="h-5 w-5 text-danger" />
            Incomplete Sets:
            <p v-if="courseInfoFetched">{{ progressData?.flashcard?.sets_incomplete }}</p>
            <p v-else>0</p>
          </span>

          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-exclamation" class="h-5 w-5 text-warning" />
            Started Sets:
            <p v-if="courseInfoFetched">{{ progressData?.flashcard?.sets_started }}</p>
            <p v-else>0</p>
          </span>
        </div>
        <div>
          <radial-progress-bar
            :diameter="95"
            :completed-steps="progressData?.flashcard?.sets_completed"
            :total-steps="progressData?.flashcard?.sets_total"
            :animateSpeed="1000"
            timingFunc="ease"
            innerStrokeColor="#222f44"
            startColor="#31B952"
            stopColor="#0cdc62"
            :strokeWidth="6"
            :innerStrokeWidth="6"
          >
            <h2 v-if="courseInfoFetched" class="font-light">{{ progressData?.flashcard?.sets_percent }}%</h2>
            <h2 v-else class="font-light">0%</h2>
          </radial-progress-bar>
        </div>
      </div>


      <div class="flex justify-between items-center main-top-border p-4">
        <div>
          <h4 class="mb-1">ExamEdge</h4>
          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-check" class="h-5 w-5 text-success" />
            Completed Asgmts:
            <p v-if="courseInfoFetched">{{ progressData?.examedge?.assignments_completed }}</p>
            <p v-else>0</p>
          </span>

          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-x" class="h-5 w-5 text-danger" />
            Incomplete Asgmts:
            <p v-if="courseInfoFetched">{{ progressData?.examedge?.assignments_total - progressData?.examedge?.assignments_completed }}</p>
            <p v-else>0</p>
          </span>

          <span class="flex items-center gap-x-2">
            <font-awesome-icon icon="fa-regular fa-circle-exclamation" class="h-5 w-5 text-warning" />
            Total Attempts:
            <p v-if="courseInfoFetched">{{ progressData?.examedge?.attempts_total }}</p>
            <p v-else>0</p>
          </span>
        </div>
        <div>
          <radial-progress-bar
            :diameter="95"
            :completed-steps="progressData?.examedge?.assignments_completed"
            :total-steps="progressData?.examedge?.assignments_total"
            :animateSpeed="1000"
            timingFunc="ease"
            innerStrokeColor="#222f44"
            startColor="#31B952"
            stopColor="#0cdc62"
            :strokeWidth="6"
            :innerStrokeWidth="6"
          >
            <h2 v-if="courseInfoFetched && examEdgePercentFormatted !== 'NaN'" class="font-light">{{ examEdgePercentFormatted }}%</h2>
            <h2 v-else class="font-light">0%</h2>
          </radial-progress-bar>
        </div>
      </div>
    </div>
</template>

<script>

import Prism from 'vue-prism-component'
import RadialProgressBar from 'vue-radial-progress'


export default {
  data () {
    return {
      courseInfoFetched: false,
      examEdgePercentFormatted: 0,
      progressData: {},
    }
  },
  methods: {
    fetchCourseProgressData() {
      this.$http
        .get(`https://connect-api.intellectualpoint.com/v1/courses/${this.activeCourseInfo.id}/report?userID=@me`)
        .then((response) => {
          this.progressData = response.data.data.report
          const examEdgePercent = this.progressData.examedge.assignments_completed / this.progressData.examedge.assignments_total
          this.examEdgePercentFormatted = (examEdgePercent * 100).toFixed(0)
          this.courseInfoFetched = true
        })
        .catch((error) => {
          console.error('Error fetching progress data:', error);
        });
    },

    fetchCourseProgressPrelimCheck() {
      if (!this.courseInfoFetched) {
        this.fetchCourseProgressData()
      }
    },
  },
  components: {
    Prism,
    RadialProgressBar
  },
  computed: {
    activeCourseInfo() {
      return this.$store.state.AppActiveCourse
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  mounted() {
    this.fetchCourseProgressPrelimCheck()
  },

}
</script>